import { casesService, GET_CASE_COUNT } from '@/api';
import {
	Button,
	Carousel,
	CaseCard,
	Spinner,
	Typography,
} from '@/components/common';
import AppRoutes from '@/const/routes';
import { useQuery } from '@tanstack/react-query';
import { useInternalCaseFilter } from '@/hooks';

export const EmptyCasesDashboardScreen: React.FC = () => {
	const { data: cases, isFetching } = useQuery({
		queryKey: [GET_CASE_COUNT],
		queryFn: () => casesService.getByQuantity(20),
	});
	const { filterInternalCases } = useInternalCaseFilter();
	const casesData = filterInternalCases(cases?.data.items || []);
	return (
		<div className="flex flex-col justify-between h-full">
			<div className="flex flex-col items-center space-y-6 flex-1">
				<Typography type="semibold-30">No Ongoing Cases</Typography>
				<Typography type="regular-16">
					You haven’t applied to any cases yet
				</Typography>
				<Button
					decoration="primary"
					size="medium"
					href={AppRoutes.CLIENTAPP_ALL_CASES}
				>
					Explore All Cases
				</Button>
			</div>
			<div className="flex flex-col items-center space-y-4 flex-1">
				<Typography type="semibold-30" className="text-center">
					File a <span className="text-primary">Claim</span> Today
				</Typography>
				<Typography type="regular-18" className="text-center">
					See if You Qualify in Less than 5 minutes
				</Typography>

				{isFetching ? (
					<Spinner type="loadingPage" />
				) : (
					<Carousel
						classNameContainer="!pl-0"
						classNameControls="!pr-0 !mt-8"
						classNameEmblaContainer="embla__container__dashboard"
					>
						{casesData.map((value, index) => (
							<div className="embla__slide" key={index}>
								<CaseCard
									{...value}
									isDescription={false}
									titleSize="semibold-18"
									className="h-[226px] !p-8 relative"
									classNameButton="!h-[30px] !py-4 max-w-max"
								/>
							</div>
						))}
					</Carousel>
				)}
			</div>
		</div>
	);
};
